import { deactivateOrganisationUser } from '@infuse/api/iam/organisation';
import { deactivateTenantUser } from '@infuse/api/iam/tenant';
import { deactivateUser } from '@infuse/api/iam/user';
import { UserLevel } from '@infuse/iam/user/type';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { useGenericDeactivateUser } from './generic/useGenericDeactivateUser';

export const useDeactivateUser = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericDeactivateUser({
      apiFn: deactivateOrganisationUser,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericDeactivateUser({
      apiFn: deactivateTenantUser,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericDeactivateUser({
    apiFn: deactivateUser
  });
};
